import React, { useCallback, useState } from "react";
import Sidebar from "./Sidebar";

const DEFAULT_WRAPPER_SPACING = "px-8 pt-2 pb-2 md:pt-2 md:pb-2 md:pr-2";

export const AuthenticatedLayout = ({
  children,
  contentClassName,
  wrapperClassName = DEFAULT_WRAPPER_SPACING,
  useCustomOuterSpacing = false,
  isFullWidth = false,
}) => {
  const [sidebarMode, setSidebarMode] = useState(() => {
    if (typeof window === "undefined") {
      return "expanded";
    }
    const storedMode = window.localStorage.getItem("sidebarMode");
    return storedMode === "compact" ? "compact" : "expanded";
  });

  const handleSidebarModeChange = useCallback((nextMode) => {
    setSidebarMode(nextMode);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("sidebarMode", nextMode);
    }
  }, []);

  const isExpanded = sidebarMode === "expanded";
  const leftPaddingClass =
    useCustomOuterSpacing === true
      ? ""
      : isExpanded
        ? "pl-2 md:pl-[calc(11rem+0.5rem)]"
        : "pl-2 md:pl-[calc(5rem+0.0rem)]"; // add small gap between compact sidebar and content
  const baseHorizontalPadding = useCustomOuterSpacing ? "" : "pr-2";
  const baseVerticalPadding = useCustomOuterSpacing ? "" : "py-4 md:py-6";
  const rightPaddingClass = useCustomOuterSpacing === true ? "" : "md:pr-2";
  const contentPaddingClass = "w-full";
  const trimmedContentClass = typeof contentClassName === "string" ? contentClassName.trim() : "";
  const widthClass = trimmedContentClass.length > 0 ? trimmedContentClass : "max-w-6xl";
  const shouldCenterContent = isFullWidth !== true;

  return (
    <div
      className={`relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 transition-[padding] duration-300 ease-in-out ${baseVerticalPadding} ${baseHorizontalPadding} ${leftPaddingClass} ${rightPaddingClass} ${wrapperClassName}`}
    >
      <div className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute -top-40 left-32 h-72 w-72 rounded-full bg-indigo-500/30 blur-3xl" />
        <div className="absolute bottom-10 right-10 h-80 w-80 rounded-full bg-cyan-500/20 blur-3xl" />
        <div className="absolute -bottom-32 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-emerald-500/10 blur-3xl" />
      </div>
      <Sidebar mode={sidebarMode} onModeChange={handleSidebarModeChange} />
      <main
        className={`relative z-10 ${shouldCenterContent ? "mx-auto" : ""} w-full ${
          shouldCenterContent ? widthClass : trimmedContentClass
        } transition-all duration-300 ease-in-out`}
      >
        <div className={contentPaddingClass}>{children}</div>
      </main>
    </div>
  );
};

export default AuthenticatedLayout;
